import { render, staticRenderFns } from "./BankReconciliationColumnHeader.vue?vue&type=template&id=2cb7c67a&scoped=true&"
import script from "./BankReconciliationColumnHeader.vue?vue&type=script&lang=js&"
export * from "./BankReconciliationColumnHeader.vue?vue&type=script&lang=js&"
import style0 from "./BankReconciliationColumnHeader.vue?vue&type=style&index=0&id=2cb7c67a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb7c67a",
  null
  
)

export default component.exports